/* =========================================================
	SITE NAVIGATION
========================================================= */

let scrollpos = window.scrollY;
const content = document.querySelector('main[role="document"]');
const mobileNavTrigger = document.querySelector('.mobile-nav-trigger');
const mobileNavContainer = document.querySelector('.nav-min');
const expander = document.querySelector ('.nav-min .expander');

// Opens/closes mobile nav & adds classes where needed
mobileNavTrigger.addEventListener('click', () => {
	content.classList.toggle('nav-open');
   mobileNavContainer.classList.toggle('is-open');
   expander.classList.toggle('is-expanded');
	expander.slideToggle(300);
});

// Opens/closes each section link in mobile nav
document.querySelector('.nav-links').addEventListener('click', function(e) {
	if (e.target.classList.contains('meganav-trigger')) {
		e.target.classList.toggle('is-open');
		var meganavPanel = e.target.nextElementSibling;
		meganavPanel.slideToggle(200);

		// Make other panels collapse when one is opened
		document.querySelectorAll('.nav-links .meganav-panel').forEach(function(el) {
			if (el.style.display !== "none" && el !== meganavPanel) {
				// Change icon on other panels when one is opened
				el.previousElementSibling.classList.remove('is-open');
				// Close panel
				el.slideUp(200);
			}
		});
	}
});

// Add/remove class on scroll
const header = document.querySelector('.nav-max');
const siteMessageMin = document.querySelector('header.nav-min .site-alert');
const siteMessageMax = document.querySelector('header.nav-max .site-alert');
const toTopLink = document.querySelector('.scroll-top');

toTopLink.addEventListener('click', function(e) {
	e.preventDefault();
	window.scrollTo({
		top: 0,
		behavior: 'smooth'
	});
});

window.addEventListener('scroll', function() {
	scrollpos = window.scrollY;

	// Add/remove class on scroll for desktop nav only
	if (scrollpos >= 30) {
		header.classList.add('is-sticky');
		siteMessageMin.classList.add('is-sticky');
		siteMessageMax.classList.add('is-sticky');
		toTopLink.classList.add('is-visible');
	} else {
		header.classList.remove('is-sticky');
		siteMessageMin.classList.remove('is-sticky');
		siteMessageMax.classList.remove('is-sticky');
		toTopLink.classList.remove('is-visible');
	}
});


// Set media queries
const mediaQuerySmall = window.matchMedia('(max-width: 599px)');
const mediaQueryRange = window.matchMedia('(min-width: 600px) and (max-width: 959px)');

// Get page hero elements
const homeHero = document.querySelector('.hero-home');
const standardPageHero = document.querySelector('.page-header.is-standard');

if (homeHero != null) {
	window.addEventListener("load", addHomeHeroPadding);
	window.addEventListener("resize", addHomeHeroPadding);
}

if (standardPageHero != null) {
	window.addEventListener("load", addStandardHeroPadding);
	window.addEventListener("resize", addStandardHeroPadding);
}

// Add top padding to home page hero (mobile only)
function addHomeHeroPadding(e) {
	if (mediaQuerySmall.matches && siteMessageMin != null) {
		// console.log('small and site message exists');

		// Get the site message height
		const siteMessageHeight = siteMessageMin.offsetHeight;

		// Give page home hero padding based on site message height & nav height
		homeHero.style.paddingTop = siteMessageHeight + 60 + 'px';

	} else if (mediaQueryRange.matches) {
		// console.log('is in range');

		// Give page home hero padding based on nav height
		homeHero.style.paddingTop = 60 + 'px';

	} else {
		// console.log('does not match');
		homeHero.removeAttribute('style');
	}
}

// Add top padding to page hero w/o background image (mobile only)
function addStandardHeroPadding(e) {
	if (mediaQuerySmall.matches && siteMessageMin != null) {
		// console.log('small and site message exists');

		// Get the site message height
		const siteMessageHeight = siteMessageMin.offsetHeight;

		// Give page home hero padding based on site message height & nav height
		standardPageHero.style.paddingTop = siteMessageHeight + 60 + 'px';

	} else if (mediaQueryRange.matches) {
		// console.log('is in range');

		// Give page home hero padding based on nav height
		standardPageHero.style.paddingTop = 60 + 'px';

	} else {
		// console.log('does not match');
		standardPageHero.removeAttribute('style');
	}
}
